import React from "react";

import "./ErrorPages.css";

const ErrorPages = ({ errorCode, filename }) => {
    switch (errorCode) {
        case 7000:
            return (
                <div className="general">
                    <img className="veriff-logo-with-name" alt="veriff-logo" src="/veriff-logo-with-text.png" />
                    <div>
                        <h2 className="title">Houston, we have a problem!</h2>
                        <p className="desc">
                            {" "}
                            All the files seem to have been uploaded just fine! <br></br>
                            However , an issue seems to be occured at a final step.<br></br>
                            Contact us and we will figure it out.<br></br>
                            <br></br>
                            p.s. There is no need to reupload the files.
                        </p>
                    </div>
                </div>
            );
        case 7001:
            return (
                <div className="general">
                    <img className="veriff-logo-with-name" alt="veriff-logo" src="/veriff-logo-with-text.png" />

                    <div>
                        <h2 className="title">Invalid folder structure</h2>
                        <p className="desc">
                            {" "}
                            Please make sure that folder tree seems like below: <br></br>
                            /main_folder/session1/face.png <br></br>
                            <br></br>
                        </p>
                        <div className="structure">
                            <div className="struct-only-folder">
                                <img alt="folder-icon" src="/icon-folder.svg" />
                                <div className="folder-name">Company_name</div>
                            </div>
                            <div className="inner-rectangle">
                                <div className="struct-only-folder">
                                    <img alt="folder-icon" src="/icon-folder.svg" />
                                    <div className="folder-name">sessionID01</div>
                                </div>
                                <div className="struct-file">
                                    <img className="file-icon" alt="file-icon" src="/icon-file-purple.svg" />
                                    <div className="folder-name">sessionID01_back.png</div>
                                </div>
                                <div className="struct-file">
                                    <img className="file-icon" alt="file-icon" src="/icon-file-yellow.svg" />
                                    <div className="folder-name">sessionID01_front.png</div>
                                </div>
                                <div className="struct-file">
                                    <img className="file-icon" alt="file-icon" src="/icon-file-green.svg" />
                                    <div className="folder-name">sessionID01_face.png</div>
                                </div>
                            </div>
                            <div className="inner-rectangle">
                                <div className="struct-only-folder">
                                    <img alt="folder-icon" src="/icon-folder.svg" />
                                    <div className="folder-name">sessionID02</div>
                                </div>
                                <div className="struct-file">
                                    <img className="file-icon" alt="file-icon" src="/icon-file-purple.svg" />
                                    <div className="folder-name">sessionID02_back.png</div>
                                </div>
                                <div className="struct-file">
                                    <img className="file-icon" alt="file-icon" src="/icon-file-yellow.svg" />
                                    <div className="folder-name">sessionID02_front.png</div>
                                </div>
                                <div className="struct-file">
                                    <img className="file-icon" alt="file-icon" src="/icon-file-green.svg" />
                                    <div className="folder-name">sessionID02_face.png</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        case 7002:
            return (
                <div className="general">
                    <img className="veriff-logo-with-name" alt="veriff-logo" src="/veriff-logo-with-text.png" />
                    <div>
                        <h2 className="title">Houston, we have a problem!</h2>

                        <p className="desc">
                            {" "}
                            Please dont use white spaces in file and folder names <br></br>
                            Correct path : /main_folder/session0001/face.png <br></br>
                            Wrong path : /main_folder/session 0001/face.png <br></br>
                            Wrong path : /main folder/session0001/face.png
                        </p>
                    </div>
                </div>
            );
        case 7003:
            return (
                <div className="general">
                    <img className="veriff-logo-with-name" alt="veriff-logo" src="/veriff-logo-with-text.png" />

                    <div>
                        <h2 className="title">Houston, we have a problem!</h2>

                        <p className="desc">
                            {" "}
                            Please reduce the file size under 18 MB for : <br></br>
                            {filename}
                        </p>
                    </div>
                </div>
            );
        default:
            return (
                <div className="general">
                    <img className="veriff-logo-with-name" alt="veriff-logo" src="/veriff-logo-with-text.png" />

                    <div>
                        <div className="title">Something went wrong</div>
                        <div className="desc">
                            <p>
                                {" "}
                                Contact us and we will figure it out <br></br>
                            </p>
                        </div>
                    </div>
                </div>
            );
    }
};

export default ErrorPages;
